import { getDateFromString, QuoteToolPreselectedModes } from '@lx/shared/utils';
import { inject, Injectable } from '@angular/core';
import { HostDataReaderService } from '../../host-data-reader';
import { DeepLinkParametersEnum, JuniorCampDeepLinkParameters, JuniorCampDeepLinkParametersSchema } from '../deep-link-parameters';
import { ZodSafeParseResult } from 'zod';

@Injectable({
  providedIn: 'root',
})
export class JuniorCampModeStrategyHelperService {
  private readonly hostDataReader = inject(HostDataReaderService);

  getDeepLinkParameters(): JuniorCampDeepLinkParameters {
    // Get query params from URL
    const queryParams = this.hostDataReader.getQueryParams();
    const quoteToolModeQueryParam = this.hostDataReader.getQuoteToolMode();
    return {
      preselectedMode: quoteToolModeQueryParam ? (quoteToolModeQueryParam as QuoteToolPreselectedModes) : undefined,
      schoolCode: queryParams.get(DeepLinkParametersEnum.schoolCode) || undefined,
      packageCode: queryParams.get(DeepLinkParametersEnum.packageCode) || undefined,
      duration: Number(queryParams.get(DeepLinkParametersEnum.duration)) || undefined,
      startDate: getDateFromString(queryParams.get(DeepLinkParametersEnum.startDate)) || undefined,
      endDate: getDateFromString(queryParams.get(DeepLinkParametersEnum.endDate)) || undefined,
      deeplinkType: queryParams.get(DeepLinkParametersEnum.deeplinkType) || undefined,
      optOutProductCode: queryParams.get(DeepLinkParametersEnum.optOutProductCode) || undefined,
      optOutProductInfo: queryParams.get(DeepLinkParametersEnum.optOutProductInfo) || undefined,
    };
  }

  parseDeepLinkParameters(deepLinkParameters: JuniorCampDeepLinkParameters): ZodSafeParseResult<Partial<JuniorCampDeepLinkParameters>> {
    return JuniorCampDeepLinkParametersSchema.safeParse(deepLinkParameters);
  }
}
